import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SearchInputComponent } from './search-input/search-input.component';
import { ISearchOption } from '../../../interfaces/search.interface';
import { ViewersService } from '../../../services/viewers.service';
import { Subscription, take } from 'rxjs';
import { MapViewerNode } from '@3ddv/dvm-internal';
import { DvmFormatterPipe } from '../../../pipes/dvm-formatter.pipe';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [SearchInputComponent],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  public searchData: ISearchOption[];

  constructor(
    private readonly viewersService: ViewersService,
    private cdr: ChangeDetectorRef
  ) {
    this.searchData = [];
  }

  ngOnInit(): void {
    // Get data for the search list
    this.updateSearchData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  // INIT METHODS

  private updateSearchData(): void {
    if (!this.viewersService.viewer.isLoaded()) {
      const loadSuccess: Subscription = this.viewersService.viewer.getObservable('load_success').pipe(take(1)).subscribe((): void => this.getSectionsList())
      this.subscriptions.push(loadSuccess);
    } else {
      this.getSectionsList();
    }
  }

  private getSectionsList(): void {
    const formatter: DvmFormatterPipe = new DvmFormatterPipe(),
          sectionNodes: MapViewerNode[] = this.viewersService.viewer.getNodesByType('section'),
          inputOptions: ISearchOption[] = sectionNodes.map((node: MapViewerNode) => ({ label: formatter.transform(node.id), value: node.id }));
    this.searchData.push(...inputOptions);
    // console.log('Search Data: ', this.searchData);
  }

  // ACTIONS METHODS

  // Filter values (search list)
  public filterSections(values: ISearchOption[]): void {
    // console.log('Filtered options:', values);
    if (values.length) {
      const nodeIds: string[] = values.map((value: ISearchOption) => value.value);
      this.viewersService.setAvailability('section', nodeIds);
    } else {
      this.viewersService.setAvailability();
      this.viewersService.viewer.hover(null);
    }
    
    // Force change detection: Call detectChanges to update the view
    // this.cdr.detectChanges();
    this.cdr.markForCheck();
  }

  // Hover value (search list)
  public highlightSection(value: ISearchOption | undefined): void {
    // console.log('Hovered option:', value);
    this.viewersService.viewer.hover(null);
    if (value) this.viewersService.viewer.hover(value.value);
    
    // Force change detection: Call detectChanges to update the view
    // this.cdr.detectChanges();
    this.cdr.markForCheck();
  }

  // Update/Select value (search list)
  public selectAndNavigateToSection(value: ISearchOption | null): void {
    console.log('Selected option:', value);
    if (!value) return;

    // Enter section
    const sectionId: string = value.value;
    const navigate = this.viewersService.navigateToSection(sectionId).subscribe();
    this.subscriptions.push(navigate);
    
    // Force change detection: Call detectChanges to update the view
    // this.cdr.detectChanges();
    this.cdr.markForCheck();
  }


}
